import dd, { device, biz, runtime } from 'dingtalk-jsapi'
import { getDate } from '@/utils/tool'

/* eslint-disable */
class DD {
  constructor() {
    this.inDingtalk = dd.env.platform && dd.env.platform !== 'notInDingTalk'
    // console.log(device.base.getPhoneInfo({
    //   success: d => console.log(d)
    // }))
  }
  /**
   * 确认框
   * @param {*标题} title
   * @param {*内容} content
   * @param {*确认按钮文字} confirmButtonText
   * @param {*取消按钮文字} cancelButtonText
   */
  inDingtalk = false
  confirm (title = '温馨提示', message = '', buttonLabels = ['确定', '取消']) {
    return new Promise((resolve, reject) => {
      device.notification.confirm({
        title, message, buttonLabels,
        onSuccess: (result) => { resolve(result) },
        onFail: (result) => {
        }
      }).catch(e => {});
    });
  }
  /**
   * 弹出框
   * @param {*提示内容} message
   * @param {*提示标题} title
   * @param {*按钮名称} buttonName
   */
  alert (message = '欢迎光临', title = '温馨提示', buttonName = '确定') {
    return new Promise((resolve, reject) => {
      device.notification.alert({
        message,
        title,
        buttonName,
        onSuccess () { resolve(); },
        onFail (err) {
          // reject()
        }
      }).catch(e => {});
    });
  }
  /**
   * 提示框
   * @param {*类型} type toast的类型 alert, success, error, warning, information, confirm
   * @param {*提示信息} text
   * @param {*显示持续时间} duration 显示持续时间，单位秒，最短2秒，最长5秒
   * @param {*延迟事件} delay 延迟显示，单位秒，默认0, 最大限制为10
   */
  toast (type = 'success', text = "消息提示", duration = 3, delay = 0) {
    device.notification.toast({
      type,
      text,
      duration,
      delay,
      onSuccess: function (result) {
        /*{}*/
      },
      onFail: function (err) { }
    })
  }
  actionSheet ({ title = '请选择', cancelButton = '取消', options = [] }) {
    const otherButtons = options.map(({ label }) => label)
    return new Promise((resolve, reject) => {
      device.notification.actionSheet({
        title,
        cancelButton,
        otherButtons,
        onSuccess : function(result) {
          const { buttonIndex } = result
          const checked = options[buttonIndex]
          resolve(checked)
        },
        onFail : function(err) {
          reject(err)
        }
      })
    })
  }
  dateTimePicker ({ format = 'yyyy/MM/dd HH:mm', value }) {
    const { platform } = dd.env
    if (platform === 'android' || platform === 'ios') {
      return new Promise((resolve, reject) => {
        biz.util.datetimepicker({
          format,
          value: getDate(value || Date.now(), format),
          onSuccess: function(result) {
            resolve(+new Date(result.value.replace(/-/g, '/')))
          },
          onFail: function(err) {
            reject(err)
          }
        })
      })
    }
    return Promise.resolve(Date.now() + 86400000)
  }
  /**
   *
   * @param {*Array} urls
   * @param {*String} current
   */
  previewImage (urls = [], current = "") {
    biz.util.previewImage({
      urls,//图片地址列表
      current,//当前显示的图片链接
      onSuccess: function (result) {
        /**/
      },
      onFail: function () { }
    })
  }
  /**
   * 钉钉免登授权
   * @param {*企业ID} corpId
   */
  auth (corpId) {
    return new Promise((resolve, reject) => {
      runtime.permission.requestAuthCode({
        corpId,
        onSuccess (result) { resolve(result) },
        onFail (err) { reject(err) }
      })
    });
  }
  /**
   * 获取用户信息
   */
  getInfo () {
    const that = this;
    biz.user.get({
      onSuccess (info) {
        that.alert(JSON.stringify(info));
      },
      onFail (err) {
        that.alert(JSON.stringify(err));
      }
    });
  }
  // 打开右侧抽屉
  openSlidePanel (url = 'about:blank', title = 'title') {
    new Promise((resolve, reject) => {
      biz.util.openSlidePanel({
        url, //打开侧边栏的url
        title, //侧边栏顶部标题
        onSuccess: function (result) {
          resolve(result);
          /*
            调用biz.navigation.quit接口进入onSuccess,
            result为调用biz.navigation.quit传入的数值
          */
        },
        onFail: function (result) {
          reject(result);
          /*
            tips:点击右上角上角关闭按钮会进入onFail
          */
        }
      })
    })
  }
  // 下载文件
  DownloadFile (url, name) {
    biz.util.downloadFile({
      url, //要下载的文件的url
      name, //定义下载文件名字
      onProgress: function (msg) {
        // 文件下载进度回调
      },
      onSuccess: function (result) {
        /*
          true
        */
      },
      onFail: function () { }
    })
  }
  // 用 openLink API，然后 然后 query string 加一个ddtab=true
  openLink (url) {
    biz.util.openLink({
      url,//要打开链接的地址
      onSuccess: function (result) {
        /**/
      },
      onFail: function (err) { }
    }
    )
  }
  // 删除
  deleteSpace (spaceId, dentryId) {
    biz.cspace.delete({
      spaceId, dentryId, onSuccess (result) {
      }
    })
  }
  quit () {
    const { platform } = dd.env
    if (platform === 'pc') {
      biz.navigation.quit()
    } else if (platform === 'android' || platform === 'ios') {
      biz.navigation.close()
    } else {
      window.close()
    }
  }
  // 操作 storage
  storage = {
    get (name) {
      return new Promise(resolve => {
        const v = localStorage.getItem(name)
        resolve(v)
      })
    },
    set (name, value) {
      return new Promise((resolve, reject) => {
        try {
          const reg = /<img\ssrc=\S{0,3}data:image\S{2,10}base64/g;
          if(reg.test(value)) {
            reject('自动保存图片失败')
          }
          localStorage.setItem(name, value)
          resolve()
        }
        catch (err) {
          reject(err)
        }
      })
    },
    remove (name) {
      return new Promise(resolve => {
        localStorage.removeItem(name)
        resolve()
      })
    },
    old: ''
  }
};
export default new DD();
